import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledSubpageContainer = styled.section<{ overflow?: string; mdOverflow?: string }>`
	${(p) => css`
		width: 100%;

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		padding: 0;
		padding-bottom: ${p.theme.spacing.s};

		position: absolute;
		left: 0;
		height: 85vh;

		max-height: 1000px;

		${mq(
			EMediaQuery.md,
			`
		justify-content: flex-start;
		height: 100%; // fallback value, the height should be updated by code
		padding: 0;
	
		${p.mdOverflow ? `overflow: ${p.mdOverflow};` : 'overflow: hidden auto;'}
		`
		)}
	`}
`;
